import React from "react";

import { TransitionProposal } from "@fartherfinance/frontend/api/TransitionProposals/types";

import { strings } from "../strings";
import Button from "@src/multiCustodian/components/MUI/Button/Button";
import Modal from "@src/sharedComponents/Modal/Modal";
import Text from "@src/sharedComponents/Typography/Text";

import styles from "./ConfirmShareProposalModal.module.css";

interface Props {
  isOpen: boolean;
  onClose: () => void;
  onConfirmShare: () => void;
  isLoading?: boolean;
  transitionProposal: TransitionProposal;
  clientFullName?: string;
}

const ConfirmShareProposalModal: React.FC<Props> = ({
  isOpen,
  onClose,
  onConfirmShare,
  isLoading = false,
  transitionProposal,
  clientFullName,
}) => {
  return (
    <Modal
      isOpen={isOpen}
      closeModal={onClose}
      modalStyle={{
        width: 518,
      }}
      showCloseButton
    >
      <div className={styles.modalContent}>
        <Text variant="title1" className={styles.modalTitle}>
          {strings.SHARE_PROPOSAL_TITLE}
        </Text>
        <Text variant="body" className={styles.modalDescription}>
          You are about to share the "{transitionProposal.name}" with{" "}
          {clientFullName}.
        </Text>
        <div className={styles.modalButtons}>
          <Button
            variant="outlined"
            onClick={onClose}
            disabled={isLoading}
            text={strings.CANCEL_BUTTON}
            buttonType="primary"
          />
          <Button
            variant="contained"
            text={strings.SHARE_BUTTON}
            onClick={onConfirmShare}
            disabled={isLoading}
            buttonType="primary"
          />
        </div>
      </div>
    </Modal>
  );
};

export default ConfirmShareProposalModal;
